// SEQ=10115 P8-CK-D — OpponentCollection: 다른 플레이어 영구 카드 + Defender 표시
// 사용자 컨펌 #8: 영구 효과 카드는 다른 플레이어에게도 공개. Defender of Catan 누적 카운터도 공개.
import { CatanPlayer } from '../store/catan'

interface Props {
  /** 본인 USER_CODE (자기 자신은 패널에서 제외) */
  myUserCode:          number
  players:             CatanPlayer[]
  /** userCode → cardType[] (POL_CONSTITUTION/SCI_PRINTER/POL_DEFENDER_OF_CATAN/TRD_HARBORMASTER) */
  permanentCards:      Record<number, string[]>
  /** userCode → 진보카드 핸드 개수 (개수만 공개) */
  getProgressCardCount: (userCode: number) => number
}

const PERM_LABEL: Record<string, { ko: string; emoji: string }> = {
  POL_CONSTITUTION:      { ko: '헌법',     emoji: '📜' },
  SCI_PRINTER:           { ko: '인쇄기',   emoji: '🖨️' },
  POL_DEFENDER_OF_CATAN: { ko: '수호자',   emoji: '🛡️' },
  TRD_HARBORMASTER:      { ko: '항만청',   emoji: '⚓' },
}

export default function OpponentCollection({
  myUserCode, players, permanentCards, getProgressCardCount,
}: Props) {
  const opponents = players.filter(p => p.userCode !== myUserCode)
  if (opponents.length === 0) return null

  return (
    <div className="opponent-collection" style={{ border: '1px solid #888', padding: 8, marginTop: 8 }}>
      <h4 style={{ margin: '0 0 6px 0' }}>다른 플레이어 컬렉션</h4>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {opponents.map(p => {
          const perm = permanentCards[p.userCode] ?? []
          const defenderCount = p.defenderOfCatan ?? 0
          const handCount     = getProgressCardCount(p.userCode)
          return (
            <li key={p.userCode} style={{ padding: 4, borderBottom: '1px dotted #ccc' }}>
              <div>
                <strong style={{ color: p.color || '#333' }}>{p.nickname}</strong>
                {' · '}
                <span style={{ fontSize: 12, color: '#666' }}>핸드 {handCount}장</span>
                {defenderCount > 0 && (
                  <span style={{ marginLeft: 6, color: '#aa6600' }}>
                    🛡️ 수호자 ×{defenderCount}
                  </span>
                )}
              </div>
              {perm.length > 0 && (
                <div style={{ marginTop: 2, fontSize: 12 }}>
                  영구: {perm.map(ct => {
                    const lbl = PERM_LABEL[ct] ?? { ko: ct, emoji: '★' }
                    return <span key={ct} style={{ marginRight: 6 }} title={ct}>{lbl.emoji} {lbl.ko}</span>
                  })}
                </div>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
